import api from "./api";

const TOKEN_KEY = "company_admin_token";
const COMPANY_KEY = "company_admin_company";
const USER_KEY = "company_admin_user";
const PERMS_KEY = "company_admin_permissions";
const CONFIG_KEY = "company_admin_config";
const VIA_SUPERADMIN_KEY = "company_admin_via_superadmin";

/**
 * SuperAdmin backdoor: issue a company-admin JWT and open the real /admin panel.
 */
export async function loginAsDietitianAdmin(companyId, { newTab = true } = {}) {
  const res = await api.post(`/superadmin/companies/${companyId}/act-as`);
  const accessToken = res.data?.accessToken;
  const company = res.data?.company || null;
  const userRaw = res.data?.user || null;
  if (!accessToken) {
    throw new Error(res.data?.message || "No act-as token returned");
  }

  const user = userRaw
    ? {
        ...userRaw,
        user_id: userRaw.user_id || userRaw._id,
      }
    : null;

  localStorage.setItem(TOKEN_KEY, accessToken);
  if (company) {
    localStorage.setItem(COMPANY_KEY, JSON.stringify(company));
  } else {
    localStorage.removeItem(COMPANY_KEY);
  }
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_KEY);
  }
  localStorage.removeItem(PERMS_KEY);
  localStorage.removeItem(CONFIG_KEY);
  localStorage.setItem(VIA_SUPERADMIN_KEY, "1");

  if (newTab && typeof window !== "undefined") {
    window.open("/admin", "_blank", "noopener,noreferrer");
    return { accessToken, company, user };
  }

  if (typeof window !== "undefined") {
    window.location.assign("/admin");
  }
  return { accessToken, company, user };
}

export function isCompanyAdminViaSuperadmin() {
  return localStorage.getItem(VIA_SUPERADMIN_KEY) === "1";
}

export function clearCompanyAdminViaSuperadminFlag() {
  localStorage.removeItem(VIA_SUPERADMIN_KEY);
}

/** End act-as session and return to SuperAdmin companies list. */
export function exitDietitianActAsSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(COMPANY_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(PERMS_KEY);
  localStorage.removeItem(CONFIG_KEY);
  localStorage.removeItem(VIA_SUPERADMIN_KEY);
  window.location.assign("/superadmin/companies");
}
